import { Flower2, UserRound, AudioWaveform, ConciergeBell } from "lucide-react";
import { Reveal, ChapterLabel } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = [Flower2, UserRound, AudioWaveform, ConciergeBell];

const Why = () => {
  const { t } = useLang();
  const d = t.why;

  return (
    <section data-testid="why-section" className="bg-ivory px-6 md:px-12 py-28 md:py-44">
      <div className="mx-auto max-w-[1600px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <ChapterLabel index={d.chapter} title={d.label} />
            <Reveal delay={0.1}>
              <h2 data-testid="why-headline"
                className="mt-10 font-display text-charcoal text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight">
                {d.headingA} <span className="italic font-light">{d.headingB}</span>
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-14">
          {d.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={0.1 * i} y={36}>
                <div data-testid={`why-item-${i + 1}`} className="border-t border-charcoal/15 pt-8">
                  <Icon size={26} strokeWidth={1} className="text-gold" />
                  <p className="mt-8 label-caps text-charcoal/40">0{i + 1}</p>
                  <h3 className="mt-3 font-display text-2xl md:text-[1.7rem] leading-snug text-charcoal">{item.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-charcoal/60">{item.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Why;
